export default __webpack_public_path__ + "static/media/Inter-ExtraLight.7b7bd05c.woff";